module.exports = __webpack_public_path__ + "assets/success-icon.2eb026c3.svg";